import { PermissionMatrixState } from './partials/matrix'
import { PermissionsRoleState } from './partials/role'
import { ResourceState } from './partials/resources'
import { TeamState } from './partials/team'

export const PermissionState = _ => ({
  ...PermissionMatrixState,
  ...PermissionsRoleState,
  ...ResourceState,
  ...TeamState,
})
